export const lettersNumbersRegex = /^[A-Za-z\d ]*$/;

export const lettersNumbersRegexWithCharacterRange = (
    min: number,
    max: number,
) => {
    return new RegExp(`^[A-Za-z\\d ]{${min},${max}}`);
};
